/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/src/components/Button/Button";
import { Card } from "@/src/components/shad/card";
import { textVariants } from "@/src/components/Text/Text";
import btcGpu from "@assets/btcgpu.svg";
import { QrCode } from "lucide-react";
import { Modal } from "@/src/components/Modal/Modal";
import { useState } from "react";
import apiRoutes from "@/src/apiRoutes";
import api from "@/src/utils";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { Scanner } from "@yudiel/react-qr-scanner";
import { useNavigate } from "react-router-dom";

const Scan = () => {
  const navigate = useNavigate();
  const [openScan, setOpenScan] = useState(false);

  const submitQrCode = async (data: any) => {
    const res = await api.post(apiRoutes.qrPromo, data);
    return res.data;
  };

  const { mutate: submitQrCodeMutation } = useMutation({
    mutationFn: submitQrCode,
    onSuccess: (data) => {
      if (data?.success) {
        toast.success(data?.info);
        setOpenScan(false);
        setTimeout(() => {
          navigate("/app/wallet"); // Use this if using React Router
        }, 2000);
      } else {
        toast.warning(data?.info);
      }
    },
  });

  type QrCodeData = {
    location: string;
    secret: string;
  };

  const handleSubmit = (data: any) => {
    let newData: QrCodeData;

    try {
      newData = JSON.parse(data);
    } catch (err) {
      toast.warning("Invalid QR Code format");
      return;
    }

    if (
      typeof newData === "object" &&
      (Object.hasOwn(newData, "location") || Object.hasOwn(newData, "secret"))
    ) {
      submitQrCodeMutation({
        location: newData.location,
        secret: newData.secret,
      });
    } else {
      console.log(typeof newData);
      toast.warning("Invalid QR Code");
    }
  };

  return (
    <div className="w-full items-center justify-center">
      <Card className="md:w-6/12 mx-auto md:p-8 p-4 rounded-xl md:mt-20">
        <div className="bg-[#F6F8FF] rounded-lg p-3 w-full">
          <div>
            <h1
              className={textVariants({
                variant: "header",
                size: "xxl",
                font: "semibold",
              })}
            >
              Scan & Get Rewarded
            </h1>
            <p className={textVariants({ variant: "desc", size: "sm" })}>
              Scan the QR code and earn crypto instantly! Simply scan, verify,
              and receive your reward in your wallet. It’s that easy.
            </p>
          </div>
          <div className="h-full mt-4 ">
            <img src={btcGpu} alt="btc-gpu" className="h-full mx-auto" />
          </div>
          <div className="w-full md:mt-5 mt-3">
            <Button
              onClick={() => setOpenScan(true)}
              className="flex-1 w-full py-3 rounded-xl"
              // className="bg-blue-600 hover:bg-blue-700 text-white py-6"
            >
              <QrCode className="mr-2 h-5 w-5" />
              Scan
            </Button>
          </div>
        </div>
      </Card>
      <Modal
        open={openScan}
        setOpen={setOpenScan}
        setter="state"
        title="Scan QR Code"
        description="Scan a QR code to receive crypto rewards"
      >
        {/* <QrReader
          ref={qrRef}
          // onResult={(result, error) => {
          //   if (!!result) {
          //     setData(result?.text);
          //   }

          //   if (!!error) {
          //     console.info(error);
          //   }
          // }}
          onError={console.log}
          onScan={handleSubmit}
          style={{ width: "100%" }}
        /> */}
        <Scanner onScan={(result) => handleSubmit(result[0].rawValue)} />
      </Modal>
    </div>
  );
};

export default Scan;
